import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Box, Button, Grid, Card, CardContent, Typography, Paper, Avatar, Stack, InputAdornment, IconButton, FormControl, InputLabel, Input } from '@mui/material';
import { teal, blueGrey, deepPurple, grey} from '@mui/material/colors';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EmailIcon from '@mui/icons-material/Email';
import CallIcon from '@mui/icons-material/Call';
import { format, parse } from 'date-fns';
import SendIcon from '@mui/icons-material/Send';
import { resolveIssue, addConversation } from 'services/issues';
import { useSnackbar } from 'notistack';
import { AuthContext } from 'core/context/authContext';

const IssueDetails = ({ complaintDetails, onSuccess}) => {
  const [message, setMessage] = useState('');
  const [conversationArray, setConversationArray] = useState([])
  const {bookingDetails = {}, issueId, conversations=[]} = complaintDetails;
  const { enqueueSnackbar } = useSnackbar();
  const { userId } = useContext(AuthContext);

  useEffect(() => {
    setConversationArray([...conversations]);
  }, [conversations])
  

  function formatTime(time) {
    if(time){
      // Check correct time format and split into components
      let time1 = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      if (time1.length > 1) { // If time format correct
        time1 = time1.slice (1);  // Remove full string match value
        time1[5] = +time1[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
        time1[0] = +time1[0] % 12 || 12; // Adjust hours
      }
      return time1.join (''); // return adjusted time or original string
    }
    return time
  }

  function formatDate(date) {
    let dt = parse(date, 'dd-MM-yyyy HH:mm:ss', new Date());
    if(dt){
      return format(dt, 'dd MMM yyyy HH:mm a').toString()
    }
    return date;
  }
  
  const updateConversationArray = useCallback((text) => {
    const messageObj = {
      fromId: userId,
      text,
      toId: null,
      createdOnDateTime: format(new Date(), 'dd-MM-yyyy HH:mm:ss').toString()
    }
    setConversationArray([...conversationArray, {...messageObj}])
    setMessage('');
  }, [userId, conversationArray]);

  const sendMessage = useCallback((message)=> {
    updateConversationArray(message)
    const postData = {
      text: message,
      fromId: userId
    } 
    addConversation({...postData}, null, issueId).then(({response, error}) => {
      if(error){
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      } else {
        if(onSuccess){
          onSuccess();
        }
        enqueueSnackbar('Conversion Added', {variant: 'success'});
      }
    });
  }, [enqueueSnackbar, issueId, userId, updateConversationArray, onSuccess]);

  const replyMessage = useCallback(() => {
    sendMessage(message);
  },[message, sendMessage]);

  const onKeyDownEvent = useCallback((e) => {
    var code = (e.keyCode ? e.keyCode : e.which);
    if(code === 13) { //Enter keycode
      sendMessage(message);
    }
  },[message, sendMessage]);
  
  function onCloseIssueBtnClick() {
    resolveIssue({issueId}).then(({response, error}) => {
      if(error){
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      } else {
        if(onSuccess){
          onSuccess();
        }
        enqueueSnackbar('Issue closed', {variant: 'success'});
      }
    });
  }

  return (
    <Box  sx={{ mt: 2 }} >
      <Grid container columnSpacing={2} rowSpacing={4} justifyContent="center">
        <Grid item xs={11} sm={11} md={10} xl={10} lg={10}  >
          <Card sx={{background: teal[500], position: 'relative', overflow: 'inherit'}}>
            <Button disabled variant="outlined" sx={{textTransform: 'none', mt: -2, ml: 2, position:'absolute', background: '#fff', color: `${teal[600]} !important`, borderColor: teal[600]}}>Created By</Button>
              <CardContent sx={{pt: 4, color: '#fff'}}>
                <Typography variant="body2" gutterBottom>
                  <AccountCircleIcon sx={{verticalAlign: 'bottom', fontSize: '1.3rem'}}/> {bookingDetails?.user?.displayName}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <EmailIcon sx={{verticalAlign: 'bottom', fontSize: '1.3rem'}}/> {bookingDetails?.user?.email}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <CallIcon sx={{verticalAlign: 'bottom', fontSize: '1.3rem'}}/> {bookingDetails?.user?.mobile}
                </Typography>
              </CardContent>
          </Card>
        </Grid>
        <Grid  item xs={11} sm={11} md={10} xl={10} lg={10}  >
          <Card sx={{background: blueGrey[500], position: 'relative', overflow: 'inherit'}}>
            <Button disabled variant="outlined" 
              sx={{
                textTransform: 'none', mt: -2, ml: 2, position:'absolute', 
                background: '#fff', color: `${blueGrey[800]} !important`, borderColor: blueGrey[800 ]}}
            >
              Booking Details
            </Button>
              <CardContent sx={{pt: 4, color: '#fff'}}>
              <Typography variant="subtitle2">
                {bookingDetails?.library?.name}
              </Typography>
              <Typography variant="body1" gutterBottom>
                  {formatTime(bookingDetails?.fromTime)} - 
                  {formatTime(bookingDetails?.toTime)}
              </Typography>
              <Typography variant="caption" gutterBottom>
               {bookingDetails?.fromDate}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        {/* <Grid  item xs={11} sm={11} md={10} xl={10} lg={10}  >
          <Card sx={{background: blueGrey[500], position: 'relative', overflow: 'inherit'}}>
            <Button disabled variant="outlined" 
              sx={{
                textTransform: 'none', mt: -2, ml: 2, position:'absolute', 
                background: '#fff', color: `${blueGrey[800]} !important`, borderColor: blueGrey[800 ]}}
            >
              Property Details
            </Button>
              <CardContent sx={{pt: 4, color: '#fff'}}>
              <Typography variant="h6" gutterBottom>
                {property?.name}
              </Typography>
              <Typography variant="body1" >
                {property?.area}
              </Typography>
              <Typography variant="body1" gutterBottom>
               {property?.city}
              </Typography>
            </CardContent>
          </Card>
        </Grid> */}
        <Grid container item className='issue-chats'>
          {conversationArray.map((message, index) => (
            <Grid  item xs={12} sm={12} md={12} xl={12} lg={12 } key={index} >
              <Box className={`chat-body ${message.fromId === userId ? 'from-msg': 'reply-msg'}`}>
                <Stack direction={message.fromId === userId ? "row-reverse" : "row"} spacing={1} >
                  <Avatar sx={{ bgcolor: message.fromId === userId ? deepPurple[100] : grey[300] , width: '30px', height: '30px' }}/>
                  <Paper className='text'>{message.text}</Paper>
                </Stack>
                <Typography variant="caption" gutterBottom sx={{fontSize: '.7rem', color: '#a7a7a7'}}>
                  {formatDate(message?.createdOnDateTime)}
                </Typography>
              </Box>
            </Grid>
          ))}
          <Grid  item xs={12} sm={12} md={12} xl={12} lg={12} >
            <FormControl fullWidth sx={{ m: 1}} variant="standard">
              <InputLabel  htmlFor="reply">Your Message</InputLabel>
              <Input
                id="reply"
                value={message}
                onChange={e=>setMessage(e.target.value)}
                onKeyDown={onKeyDownEvent}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={replyMessage}>
                      <SendIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid  item xs={12} sm={12} md={12} xl={12} lg={12} textAlign="center">
              <Button variant="contained" color="warning" sx={{textTransform: 'none', mt: 3}} onClick={onCloseIssueBtnClick}>Close Issue</Button>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
 
export default React.memo(IssueDetails);
